"use strict";

module.exports = function prettierBytes(input) {
  if (typeof input !== 'number' || Number.isNaN(input)) {
    throw new TypeError("Expected a number, got ".concat(typeof input));
  }
  var neg = input < 0;
  var num = Math.abs(input);
  if (neg) {
    num = -num;
  }
  if (num === 0) {
    return '0 B';
  }
  var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
  var value = Number(num / 1024 ** exponent);
  var unit = units[exponent];
  return "".concat(value >= 10 || value % 1 === 0 ? Math.round(value) : value.toFixed(1), " ").concat(unit);
};